import { render, staticRenderFns } from "./DiffLink.vue?vue&type=template&id=796015f1"
import script from "./DiffLink.vue?vue&type=script&lang=js"
export * from "./DiffLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports